export const appConfig = {
	buildingPermitsTitle: 'דרישות להיתרי בניה' ,
	businessLicensingTitle: 'דרישות לרישוי עסקים'
};



// WEBPACK FOOTER //
// ./src/assets/config/app.config.ts